var newsList = {
	noResults: "Geen resultaten gevonden",
	readMore: "Meer",
	estimatedReadingTime: "~{minutes} min leestijd"
};
var nl = {
	newsList: newsList
};

export { nl as default, newsList };
